<template>
  <div class="row justify-content-center">
    <div class="col-xxl-3 col-xl-6 col-md-6 col-sm-6" v-for="stat in stats" :key="stat.id">
      <div class="card border-0 rounded-1 mb-20">
        <div class="stat-card d-flex flex-wrap align-items-center justify-content-between">
          <div class="stat-icon d-flex flex-column justify-content-center">
            <img :src="stat.imgBlur" alt="" class="blur-icon" />
            <img :src="stat.img" alt="" />
          </div>
          <div class="stat-info text-end">
            <span class="d-block fs-14 fw-medium">{{ stat.title }}</span>
            <div v-if="loading" class="placeholder-glow"><span class="placeholder rounded-1" style="width:80px;height:28px"></span></div>
            <template v-else>
              <h4 v-if="stat.isMoney" class="fw-black mb-0 lh-1">S/ {{ fmt(stat.value) }}</h4>
              <h4 v-else class="fw-black mb-0 lh-1">{{ stat.value }}</h4>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../services/api';

export default {
  name: 'StatusContent',
  data() {
    return {
      loading: true,
      resumen: null,
    };
  },
  computed: {
    stats() {
      const r = this.resumen || {};
      return [
        {
          id: 1,
          img:     require('../../assets/img/icons/wallet-money.svg'),
          imgBlur: require('../../assets/img/icons/wallet-money-2.svg'),
          title: 'VENTAS HOY',
          value: r.ventas_hoy || 0,
          isMoney: true,
        },
        {
          id: 2,
          img:     require('../../assets/img/icons/wallet-add.svg'),
          imgBlur: require('../../assets/img/icons/wallet-add-2.svg'),
          title: 'VENTAS DEL MES',
          value: r.ventas_mes || 0,
          isMoney: true,
        },
        {
          id: 3,
          img:     require('../../assets/img/icons/money-send.svg'),
          imgBlur: require('../../assets/img/icons/money-send-2.svg'),
          title: 'TRANSACCIONES HOY',
          value: r.ventas_hoy_count || 0,
          isMoney: false,
        },
        {
          id: 4,
          img:     require('../../assets/img/icons/money-change.svg'),
          imgBlur: require('../../assets/img/icons/money-change-2.svg'),
          title: 'TRANSACCIONES MES',
          value: r.ventas_mes_count || 0,
          isMoney: false,
        },
      ];
    },
  },
  async mounted() {
    try {
      const res = await api.get('/dashboard');
      this.resumen = res.data.data.resumen;
    } catch (e) {
      console.error('Dashboard KPIs', e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    fmt(v) { return Number(v).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
  },
};
</script>

<style scoped>
.stat-card {
  padding: 8px 20px;
}
.stat-icon {
  position: relative;
  width: 105px;
  min-height: 104px;
}
.blur-icon {
  position: absolute;
  top: 0;
  left: 0;
}
.stat-icon img { margin-right: auto; }
.stat-info {
  width: calc(100% - 110px);
}
.stat-info span {
  color: #a8acb2;
  letter-spacing: 0.7px;
  margin-bottom: 1px;
}
.stat-info h4 {
  color: var(--titleColor);
  font-size: 22px;
  font-weight: 800;
}
@media (min-width: 1600px) {
  .stat-card { padding: 8px 30px; }
  .stat-info h4 { font-size: 25px; }
}
</style>
